import { agentProfileBindingAgentControllerCollaborationModeSchema, agentProfileBindingAgentControllerPermissionModeSchema, agentProfileBindingModelSelectionSchema, agentProfileBindingOpenCodePermissionSchema } from "./agent-profile-binding.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/local-runtime-expected-routes.ts
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const runtimeIdentifierSchema = z$1.string().trim().min(1).max(512);
const reasonCodeSchema = z$1.string().trim().min(1).max(256);
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const getLocalRuntimeExpectedRoutesQuerySchema = z$1.strictObject({
	contractVersion: z$1.enum([
		"v2",
		"v3",
		"v4"
	]).optional(),
	deviceId: boundedIdentifierSchema,
	lane: boundedIdentifierSchema
});
const localRuntimeExpectedRouteSchema = z$1.strictObject({
	agentProfileId: boundedIdentifierSchema,
	bindingId: boundedIdentifierSchema,
	bindingState: z$1.literal("enabled_primary"),
	configurationRevision: z$1.number().int().positive().optional(),
	defaultProjectId: boundedIdentifierSchema.nullable().optional(),
	executionTarget: z$1.strictObject({
		agentControllerConversationId: z$1.string().trim().min(1).max(512).nullable(),
		agentControllerRef: boundedIdentifierSchema,
		openMeldServiceRuntimeId: runtimeIdentifierSchema
	}),
	modelSelection: agentProfileBindingModelSelectionSchema.optional(),
	agentControllerPermissionMode: agentProfileBindingAgentControllerPermissionModeSchema.optional(),
	agentControllerCollaborationMode: agentProfileBindingAgentControllerCollaborationModeSchema.optional(),
	openCodePermission: agentProfileBindingOpenCodePermissionSchema.optional(),
	profileName: z$1.string().trim().min(1).max(256).nullable(),
	reasonCodes: z$1.array(reasonCodeSchema),
	routable: z$1.boolean()
});
const localRuntimeExpectedRouteExclusionSchema = z$1.strictObject({
	agentProfileId: boundedIdentifierSchema,
	reasonCode: z$1.enum([
		"profile.inactive",
		"binding.other_runtime",
		"binding.not_routable"
	])
});
const getLocalRuntimeExpectedRoutesResponseSchema = z$1.strictObject({
	openMeldServiceRuntimeId: runtimeIdentifierSchema.nullable(),
	excludedProfiles: z$1.array(localRuntimeExpectedRouteExclusionSchema).max(400),
	expectedRoutes: z$1.array(localRuntimeExpectedRouteSchema).max(200),
	generatedAt: ISO_DATE_TIME_SCHEMA,
	runtimeResolution: z$1.enum([
		"resolved",
		"missing",
		"conflict"
	])
});
//#endregion
export { getLocalRuntimeExpectedRoutesQuerySchema, getLocalRuntimeExpectedRoutesResponseSchema, localRuntimeExpectedRouteExclusionSchema, localRuntimeExpectedRouteSchema };

//# sourceMappingURL=local-runtime-expected-routes.js.map